module.exports = __webpack_public_path__ + "../../static/img/newYearLogo.8f1d68b8.png";